export default class Accordion {
  constructor(elem, option) {
    this.elem = ".js-accordion";
    // option is a true or false value.  True dictates only one accordion open at a time.
    this.option = option;
    this.triggeredEvent = new Event("accordionToggle");
    document.addEventListener("click", (e) => {
      if (!e.target.matches(this.elem + " .js-accordion-button")) {
        return;
      } else {
        window.dispatchEvent(this.triggeredEvent);
        if (!e.target.parentElement.classList.contains("--active")) {
          if (this.option == true) {
            let elementList = document.querySelectorAll(
              this.elem + " .js-accordion-container"
            );
            Array.prototype.forEach.call(elementList, (e) => {
              e.classList.remove("--active");
            });
          }
          e.target.parentElement.classList.add("--active");
        } else {
          e.target.parentElement.classList.remove("--active");
        }
      }
    });
  }
}
